<div class="popover-wrapper">
    <div class="popover-header">{{title}}</div>
    <div class="layout-container">
        <nb-card-header>
            <nb-actions size="small">
                <nb-action class="popover-icon"
                    [nbPopover]="fontSizePop" 
                    [nbPopoverContext]="{title:'Font Size',content:content,target:'self',declaration:'fontSize',service:service}" 
                    nbPopoverPlacement="top">
                    <nb-icon icon="font-size" pack="section-menu-icons"/>
                    <!-- <svg viewBox="0 0 24 24" id="ic_title_24px" width="100%" height="100%" fill="var(--actions-icon-color)">
                        <path d="M5 4v3h5.5v12h3V7H19V4z" />
                    </svg> -->
                </nb-action>
                <nb-action title="Font Family"
                    class="popover-icon"
                    [nbPopover]="fontFamPop" 
                    [nbPopoverContext]="{title:'Font Family',content:content,target:'self',declaration:'fontFamily',service:service}">
                    <nb-icon icon="font-family" pack="section-menu-icons"/>
                    <!-- <svg viewBox="0 0 24 24" id="ic_format_shapes_24px" width="100%" height="100%" fill="var(--actions-icon-color)">
                        <path d="M23 7V1h-6v2H7V1H1v6h2v10H1v6h6v-2h10v2h6v-6h-2V7h2zM3 3h2v2H3V3zm2 18H3v-2h2v2zm12-2H7v-2H5V7h2V5h10v2h2v10h-2v2zm4 2h-2v-2h2v2zM19 5V3h2v2h-2zm-5.27 9h-3.49l-.73 2H7.89l3.4-9h1.4l3.41 9h-1.63l-.74-2zm-3.04-1.26h2.61L12 8.91l-1.31 3.83z"/>
                    </svg> -->
                </nb-action>
                <nb-action title="Text Color"
                    class="popover-icon"
                    [nbPopover]="colorPop" 
                    [nbPopoverContext]="{color:textColor,colors:undefined,content:content,property:'text',service:service,target:target}" nbPopoverPlacement="top">
                    <nb-icon icon="text-color" pack="section-menu-icons"/>
                    <!-- <svg viewBox="0 0 24 24" id="ic_format_color_text_24px" width="100%" height="100%" fill="var(--actions-icon-color)">
                        <path fill-opacity=".36" d="M0 20h24v4H0z" />
                        <path d="M11 3L5.5 17h2.25l1.12-3h6.25l1.12 3h2.25L13 3h-2zm-1.38 9L12 5.67 14.38 12H9.62z" />
                    </svg> -->
                </nb-action>
                <nb-action title="Underline">
                    <nb-icon icon="underline" pack="section-menu-icons"/>
                </nb-action>
                <nb-action title="Bold">
                    <nb-icon icon="font-weight" pack="section-menu-icons"/>
                </nb-action>
                <nb-action title="Italic">
                    <nb-icon icon="italic" pack="section-menu-icons"/>
                </nb-action>
                <nb-action title="Background Color"
                    class="popover-icon"
                    [nbPopover]="colorPop"
                    [nbPopoverContext]="{color:bgColor,colors:undefined,content:content,property:'background',service:service,target:'content'}" nbPopoverPlacement="top">
                    <nb-icon icon="paint-bucket" pack="section-menu-icons"/>
                </nb-action>
                <nb-action title="Align Left"
                    class="popover-icon" (click)="setHorizontalAlign(HorisontalAlign.ALIGN_LEFT)">
                    <nb-icon icon="text-align-left" pack="section-menu-icons"/>
                </nb-action>
                <nb-action title="Align Center"
                    class="popover-icon" (click)="setHorizontalAlign(HorisontalAlign.ALIGN_CENTER)">
                    <nb-icon icon="text-align-center" pack="section-menu-icons"/>
                </nb-action>
                <nb-action title="Align Right"
                    class="popover-icon"  (click)="setHorizontalAlign(HorisontalAlign.ALIGN_RIGHT)">
                    <nb-icon icon="text-align-right" pack="section-menu-icons"/>
                </nb-action>
                <nb-action  title="Visible"
                    class="popover-icon" (click)="onVisibilityChange(VisibilityEnum.VISIBLE,'content')">
                    <nb-icon icon="visibility" pack="section-menu-icons"/>
                    <!-- <svg viewBox="0 0 24 24" id="ic_title_24px" width="100%" height="100%" fill="var(--actions-icon-color)">
                        <path d="M5 4v3h5.5v12h3V7H19V4z" />
                    </svg> -->
                </nb-action>
                <nb-action title="Hidden"
                    class="popover-icon" (click)="onVisibilityChange(VisibilityEnum.HIDDEN,'content')">
                    <nb-icon icon="hidden" pack="section-menu-icons"/>
                    <!-- <svg viewBox="0 0 24 24" id="ic_format_shapes_24px" width="100%" height="100%" fill="var(--actions-icon-color)">
                        <path d="M23 7V1h-6v2H7V1H1v6h2v10H1v6h6v-2h10v2h6v-6h-2V7h2zM3 3h2v2H3V3zm2 18H3v-2h2v2zm12-2H7v-2H5V7h2V5h10v2h2v10h-2v2zm4 2h-2v-2h2v2zM19 5V3h2v2h-2zm-5.27 9h-3.49l-.73 2H7.89l3.4-9h1.4l3.41 9h-1.63l-.74-2zm-3.04-1.26h2.61L12 8.91l-1.31 3.83z"/>
                    </svg> -->
                </nb-action>
                <nb-action title="Hidden On Mobile"
                    class="popover-icon" (click)="onVisibilityChange(VisibilityEnum.HIDDEN_ON_MOBILE,'content')">
                    <nb-icon icon="mobile-off" pack="section-menu-icons"/>
                    <!-- <svg viewBox="0 0 24 24" id="ic_format_color_text_24px" width="100%" height="100%" fill="var(--actions-icon-color)">
                        <path fill-opacity=".36" d="M0 20h24v4H0z" />
                        <path d="M11 3L5.5 17h2.25l1.12-3h6.25l1.12 3h2.25L13 3h-2zm-1.38 9L12 5.67 14.38 12H9.62z" />
                    </svg> -->
                </nb-action>
                
                <!-- <nb-action>H Align:</nb-action>
                <nb-action title="H Align Left" (click)="setHorizontalAlign('justify-left')" class="popover-icon">
                    <svg viewBox="0 0 24 24" id="ic_format_align_left_24px" width="100%" height="100%" fill="var(--actions-icon-color)">
                        <path d="M15 15H3v2h12v-2zm0-8H3v2h12V7zM3 13h18v-2H3v2zm0 8h18v-2H3v2zM3 3v2h18V3H3z" />
                    </svg>
                </nb-action>
                <nb-action title="H Align Center" (click)="setHorizontalAlign('justify-center')" class="popover-icon">
                    <svg viewBox="0 0 24 24" id="ic_format_align_center_24px" width="100%" height="100%" fill="var(--actions-icon-color)">
                        <path d="M7 15v2h10v-2H7zm-4 6h18v-2H3v2zm0-8h18v-2H3v2zm4-6v2h10V7H7zM3 3v2h18V3H3z" />
                    </svg>
                </nb-action>
                <nb-action title="H Align Right" (click)="setHorizontalAlign('justify-right')" class="popover-icon">
                    <svg viewBox="0 0 24 24" id="ic_format_align_right_24px" width="100%" height="100%" fill="var(--actions-icon-color)">
                        <path d="M3 21h18v-2H3v2zm6-4h12v-2H9v2zm-6-4h18v-2H3v2zm6-4h12V7H9v2zM3 3v2h18V3H3z" />
                    </svg>
                </nb-action> -->
                <!-- <nb-action>
                    <nb-select [(selected)]="selectedFontFam" [placeholder]="selectedFontFam"  (selectedChange)="onChangeFontFam($event)" size="tiny" [ngStyle]="{'width':'20rem'}">
                        <nb-option *ngFor="let fontFam of fontFams" [value]="fontFam" [ngStyle]="{'font-family':''+fontFam.value+''}">{{ title?.text }}</nb-option>
                    </nb-select>
                </nb-action> -->
            </nb-actions>
            <!-- <nb-menu [items]="textMenuItems" tag="textFormatMenu"></nb-menu> -->
         </nb-card-header>
         <div class="content" [class]="theme">
            <ng-container *ngIf="content?.isHeader;else nonHeader">
                <kw-title-renderer [title]="content" preview="true" (updatedContent)="handleUpdateContent($event)"></kw-title-renderer>
            </ng-container>
            <ng-template #nonHeader>
                <kw-content-element-renderer preview="true" [contentElement]="content"></kw-content-element-renderer>
            </ng-template>

            <!-- <div class="columns">
                <div class="input-field" [class.editing]="isEditing" (click)="startEdit()">
                    //Display mode
                    <div *ngIf="!isEditing" class="display-mode">
                        <pre>{{ content || 'Click to edit...' }}</pre>
                    </div>
                    //Edit mode
                    <textarea  *ngIf="isEditing"
                        [(ngModel)]="text"
                        nbInput
                        class="form-control"
                        rows="5"
                        fullWidth
                        placeholder="Type your text here...">
                    </textarea>

                </div>
                <div class="preview-area">
                    Stuff goes here
                </div>
            </div> -->
    </div>
    </div>
</div>

